import moment from "moment";
import { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAdHocSurveyByIdAsync, updateAdHocSurveyAsync } from "../../Helpers/API/AdHocSurveyApi";
import countAttendeesAsync from "../../Helpers/API/AttendeesApi";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import SurveyMissing from "../Surveys/SurveyMissing";
import AdHocSurveyForm from "./AdHocSurveyForm";

const UpdateAdHocSurvey = () => {
	const [surveyMissing, setSurveyMissing] = useState(false);
	const navigate = useNavigate();
	const { id } = useParams();

	const [formValues, setFormValues] = useState({
		name: "",
		alchemerId: "",
		emailTemplate: "",
		sendSurveyOn: "",
		windowStartDate: "",
		windowEndDate: "",
		rules: [],
	});

	const onSubmit = (adHocSurveyObject) => {
		async function updateSurvey() {
			const { success, isSurveyMissing } = await updateAdHocSurveyAsync(id, adHocSurveyObject);
			if (success) navigate("/adhoc-surveys");
			setSurveyMissing(isSurveyMissing);
		}

		async function updateAdHocSurvey() {
			const { attendeeCount } = await countAttendeesAsync(adHocSurveyObject.rules, adHocSurveyObject.windowStartDate, adHocSurveyObject.windowEndDate);

			ConfirmDialog({
				operation: "update this, it will send",
				confirmationText: "Update it",
				entityName: `${attendeeCount} surveys`,
				onDelete: updateSurvey,
			});
		}

		updateAdHocSurvey();
	};

	useEffect(() => {
		async function getAdHocSurvey() {
			let { name, alchemerId, emailTemplate, sendSurveyOn, windowStartDate, windowEndDate, rules } = await getAdHocSurveyByIdAsync(id);

			sendSurveyOn = moment(sendSurveyOn).format("YYYY-MM-DD");
			windowStartDate = moment(windowStartDate).format("YYYY-MM-DD");
			windowEndDate = moment(windowEndDate).format("YYYY-MM-DD");

			setFormValues({
				name,
				alchemerId,
				emailTemplate,
				sendSurveyOn,
				windowStartDate,
				windowEndDate,
				rules,
			});
		}
		getAdHocSurvey();
	}, [id]);

	return (
		<div>
			<div className="breadcrumbs">
				<Breadcrumb>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						Home
					</Breadcrumb.Item>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/adhoc-surveys" }}>
						Ad-hoc Surveys
					</Breadcrumb.Item>
					<Breadcrumb.Item active>Update Survey</Breadcrumb.Item>
				</Breadcrumb>
			</div>
			<SurveyMissing isSurveyMissing={surveyMissing} />
			<AdHocSurveyForm initialValues={formValues} saveText="Update ad-hoc survey" headerText="Update an existing ad-hoc survey" onSubmit={onSubmit} />
		</div>
	);
};

export default UpdateAdHocSurvey;
